module.exports = __webpack_public_path__ + "static/media/3.8fbf900f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/3.png
// module id = 1403
// module chunks = 0